/**
 * Index Price proxy API (GET /api/index-price/history)
 */

import { API_CONFIG } from '@/config/api';
import { apiFetch } from '@/lib/apiFetch';

const BASE = API_CONFIG.INDEX_PRICE_PATH_PREFIX;

export interface IndexPriceCandle {
  ts_ms: number;
  open: number;
  high: number;
  low: number;
  close: number;
}

export interface IndexPriceHistoryResponse {
  exchange: string;
  symbol: string;
  interval: string;
  count: number;
  data: IndexPriceCandle[];
}

export type IndexPriceExchange = 'bybit' | 'okx' | 'binance' | 'gateio' | 'bitget';

export interface IndexPriceHistoryParams {
  exchange: IndexPriceExchange;
  symbol: string;
  interval?: string;
  start_ts?: number;
  end_ts?: number;
  limit?: number;
}

async function parseJsonResponse<T>(res: Response): Promise<T> {
  const contentType = res.headers.get('content-type') || '';
  const text = await res.text();
  if (!contentType.includes('application/json')) {
    throw new Error(`API 返回了非 JSON 内容（HTTP ${res.status}），请确认 index-price 后端服务已启动且代理配置已生效`);
  }
  if (!res.ok) {
    throw new Error(text || `HTTP ${res.status}`);
  }
  return JSON.parse(text) as T;
}

export async function getIndexPriceHistory(params: IndexPriceHistoryParams): Promise<IndexPriceHistoryResponse> {
  const q = new URLSearchParams();
  q.set('exchange', params.exchange);
  q.set('symbol', params.symbol.trim());
  if (params.interval != null) q.set('interval', params.interval);
  if (params.start_ts != null) q.set('start_ts', String(params.start_ts));
  if (params.end_ts != null) q.set('end_ts', String(params.end_ts));
  if (params.limit != null) q.set('limit', String(params.limit));

  const res = await apiFetch(`${BASE}/history?${q.toString()}`, { method: 'GET' });
  return parseJsonResponse<IndexPriceHistoryResponse>(res);
}
